<template>
  <WithSpinnerLoading :loading="loading" class="bid-price-offer-column-content">
    <div>
      <span>
        {{ priceFormat(priceOffer) }}
      </span>
      <ElPopover
        v-if="priceOffer < cpiLimit && isCpiLimitEnabled"
        placement="top"
        trigger="hover"
        width="250"
      >
        <span
          v-dompurify-html="
            $t('ADVERTISEMENT.CAMPAIGNS.SEARCH.CPI_LIMIT_HELP', {
              limit: cpiLimit,
            })
          "
        />
        <template #reference>
          <span class="el-icon-info bid-price-offer-column-content__info" />
        </template>
      </ElPopover>
    </div>

    <ElPopover v-model="formVisible" placement="top" trigger="click">
      <BidPriceOfferColumnForm
        :initial-price-offer="priceOffer"
        @save="closeAndSaveBid"
        @close="close"
      />
      <i v-show="isHovered" slot="reference" class="el-icon-edit pointer" />
    </ElPopover>
  </WithSpinnerLoading>
</template>

<script>
import BidPriceOfferColumnForm from './BidPriceOfferColumnContentForm';
import WithSpinnerLoading from '@@/advertisement/common/WithSpinnerLoading';

import { format as priceFormat } from '@/utils/number';

import {
  EDIT_SINGLE_CAMPAIGN_BID,
  SEARCH_ADS_CAMPAIGN_HINTS,
} from '@/store/types';
import { mapActions, mapGetters } from 'vuex';

import campaignId from '@/mixins/advertisement/campaignId';
import { IS_SEARCH_ADS_CPI_LIMIT_ENABLED } from '../..';

export default {
  name: 'BidPriceOfferColumnContent',
  components: {
    BidPriceOfferColumnForm,
    WithSpinnerLoading,
  },
  mixins: [campaignId],
  props: {
    isHovered: {
      type: Boolean,
      required: true,
    },
    id: {
      type: Number,
      required: true,
    },
    priceOffer: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      formVisible: false,
      loading: false,
    };
  },
  computed: {
    ...mapGetters({ searchAdsCampaignHints: SEARCH_ADS_CAMPAIGN_HINTS }),
    cpiLimit() {
      return this.searchAdsCampaignHints.cpiLimit;
    },
    isCpiLimitEnabled() {
      return IS_SEARCH_ADS_CPI_LIMIT_ENABLED;
    },
  },
  methods: {
    priceFormat,
    ...mapActions({
      editBid: EDIT_SINGLE_CAMPAIGN_BID,
    }),
    close() {
      this.formVisible = false;
    },
    closeAndSaveBid(priceOffer) {
      this.close();
      this.loading = true;
      return this.editBid({
        campaignId: this.campaignId,
        bidInfo: {
          id: this.id,
          priceOffer,
        },
      })
        .then(message => {
          this.$message.success(message);
        })
        .catch(({ message }) => {
          this.$message.error(message);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss">
.bid-price-offer-column-content {
  display: flex;
  justify-content: space-between;

  &__info {
    color: $lb-color-alert;
  }
}
</style>
